import { Switch } from 'react-router-dom';
import ProtectedRoute from '@app/utilities/ProtectedRoute';
import Menu from '../main/menu';
import { dashboardRoutes } from './routes';
import Sidebar from '../main/Sidebar';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getCrumbs } from '@app/utilities/helpers';

const restrictedRoutes = ['edit-story', 'read-story', 'new-story'];

function Dashboard() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const crumbs = useMemo(() => {
    return getCrumbs(pathname);
  }, [pathname]);

  return (
    <div className="flex overflow-y-hidden flex-row h-screen">
      <Menu />
      <Sidebar open={open} setOpen={setOpen} />
      <div className="flex flex-col flex-1 h-screen">
        {!restrictedRoutes.some((route) => pathname.includes(route)) && (
          <div className="w-full bg-[#FFFFFF] border-b border-[#E5E7EB] px-7 py-3.5">
            <p className="text-xl font-semibold font-outfit text-[#111827]">
              {crumbs?.title}
            </p>
          </div>
        )}

        <div className="overflow-y-auto flex-1 pb-10 min-h-screen">
          <Switch>
            {dashboardRoutes.map((route, i) => (
              <ProtectedRoute
                key={i}
                exact={route.exact}
                path={route.path}
                component={route.component}
              />
            ))}
          </Switch>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
